<template>
	<v-container grid-list-xl pa-0>
		<v-layout column>
			<v-flex>
				<v-btn
					flat
					class="ma-0 mt-3"
					color="success"
					@click="addItem"
				>
					Add Option
				</v-btn>
			</v-flex>
			
			<v-flex v-if="items.length > 0">
				<draggable
					class="draggable mt-3"
					:list="items"
					@change="reorderItems"
				>
					<v-card
						v-for="item in items"
						:key="item.id"
						class="mb-4"
						:class="{disabled_item: item.disabled}"
					>
						<v-container
							fluid
							grid-list-xl
							px-3
							py-0
						>
							<v-layout
								row
								align-center
								justify-space-between
								py-2
							>
								<v-flex
									xs12
									class="py-0"
								>
									<div class="subheading">
										<v-icon
											small
											class="mr-2"
										>
											fa-sort
										</v-icon>
										{{ item.labelText }}
									</div>
								</v-flex>
								<v-flex
									v-if="canEdit"
									class="d-flex pa-0"
								>
									<template v-if="item.disabled">
										<v-btn
											class="ma-0"
											flat
											icon
											small
											color="success"
											@click="disableItem(item)"
										>
											<v-icon>restore_from_trash</v-icon>
										</v-btn>
									</template>
									<template v-else>
										<v-btn
											class="ma-0 mr-1"
											flat
											icon
											small
											color="primary"
											@click="updateItem(item)"
										>
											<v-icon>edit</v-icon>
										</v-btn>
										<v-btn
											class="ma-0"
											flat
											icon
											small
											color="error"
											@click="disableItem(item)"
										>
											<v-icon>delete</v-icon>
										</v-btn>
									</template>
								</v-flex>
							</v-layout>
						</v-container>
					</v-card>
				</draggable>
			</v-flex>
		
			<v-dialog
				v-model="showItemForm"
				max-width="800"
			>
				<v-card>
					<v-container grid-list-xl>
						<CustomFieldItemForm
							:custom-field="customField"
							:item="itemToEdit"
							@close="createdOrUpdated"
						/>
					</v-container>
				</v-card>
			</v-dialog>
			
		</v-layout>
		
		<Confirm ref="confirm" />
		
	</v-container>
</template>

<script>
import draggable from 'vuedraggable';
import axios from '@/util/axios';
import { CustomDataItems } from '@/models/CustomData';
import CustomFieldItemForm from '@/components/Project/CustomFields/CustomFieldItemForm';
import Confirm from '@/components/Confirm';

export default {
	components: {
		draggable,
		CustomFieldItemForm,
		Confirm,
	},
	
	props: {
		customField: {
			type: Object,
			default: null,
		},
	},
	
	data() {
		return {
			showItemForm: false,
			itemToEdit: null,
		};
	},
	
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		
		canEdit() {
			return this.project.userCan('manage_custom_data') && !this.project.isArchived;
		},
		
		items() {
			return this.customField.items.models;
		},
	},
	
	methods: {
		addItem() {
			this.showItemForm = true;
			this.itemToEdit = null;
		},
		
		updateItem(item) {
			this.showItemForm = true;
			this.itemToEdit = item;
		},
		
		disableItem(item) {
			const name = item.label;
			const verb = item.disabled ? 'enable' : 'disable';

			this.$refs.confirm.createConfirm(`This will ${verb} the "${name}" option.`, 'error').then((answer) => {
				if (!answer) {
					return;
				}
				item.disabled = !item.disabled;
				item.save().then(() => {
					this.$notify('success', `Option "${name}" has been ${verb}d.`);
				}).catch(() => {
					this.$notify('error', `Failed to ${verb} option "${name}".`);
				});
			});
		},
		
		createdOrUpdated() {
			this.showItemForm = false;
			this.refetchItems();
		},
		
		refetchItems() {
			const customDataItems = new CustomDataItems();
			customDataItems.set('parentId', this.customField.id);
			customDataItems.fetch().then(() => {
				customDataItems.sort('order');
				this.customField.items = customDataItems;
			}).catch((e) => {
				dump(e);
				this.customField.items = new CustomDataItems();
				this.$notify('error', `Failed to fetch ${this.customField.label} options`);
			});
		},
		
		reorderItems() {
			const data = {
				parentId: this.customField.id,
				order: this.items.map(item => item.value),
			};
			
			axios.post('/custom-data-items/reorder', data).then().catch((e) => {
					dump('Custom data items reorder error', e);
					this.$notify('error', `Failed to reorder ${this.customField.label} options.`);
				}).finally(() => {
					this.refetchItems();
				});
		},
	},
}
</script>

<style lang="scss" scoped>
.disabled_item {
	opacity: 0.5;
}
</style>
